<div class="chip" [ngClass]="chipClass">
  {{ label }}
</div>
